<template>
  <div id="app" class="app-main">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <div class="noti-block">
      <transition-group name="noti">
        <div
          v-for="(n, i) in showNoti"
          :key="n"
          class="noti-details"
          :style="{
            backgroundColor: n['backgroundColor'] ? n['backgroundColor'] : 'lightblue',
            color: n['textColor'] ? n['textColor'] : 'black',
          }"
        >
          <img
            class="close-noti"
            v-if="n['canClose'] != 'false'"
            src="https://dsmapi.logistics.systems/dsm6gicons/icons8-close-90.png"
            alt=""
            @click="closeNotiClicked(i)"
          />
          <div>From: {{ n['from'] }}</div>
          <div>{{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm') }}</div>
          <div class="noti-text" v-html="n['text']"></div>
        </div>
      </transition-group>
    </div>
    <router-view />
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <div class="error-popup" v-if="errorDetails">
      <div class="error-content">
        <img
          v-if="errorIsNonRetryable"
          style="width: 40%"
          src="https://dsmlib.logistics.systems/Icons/SadError.gif"
          alt="sad face"
          draggable="false"
        />
        <img
          v-else-if="errorIsConnectionRelated"
          style="width: 35%; margin-bottom: 20px"
          src="https://dsmlib.logistics.systems/Icons/Disconnected.png"
          alt="connection unstable"
          draggable="false"
        />
        <img
          v-else-if="errorIsServerLoadRelated"
          style="width: 35%; margin-bottom: 20px"
          src="https://dsmlib.logistics.systems/Icons/Red Light.png"
          alt="server overloaded"
          draggable="false"
        />

        <div v-if="errorIsNonRetryable" class="error-prompt">
          <div>Oops, there is an error on this page.</div>
          <div>We are very sorry for the inconvenience.</div>
          <div>Please report this issue so that DSM6G team can solve this as soon as possible.</div>
          <div>Thank you.</div>
        </div>
        <div v-else-if="errorIsConnectionRelated" class="error-prompt">
          <div>Oops, it seems the <strong>connection is unstable</strong> at the moment.</div>
          <div>Please refresh the page and retry in a few moments.</div>
          <div>Thank you.</div>
        </div>
        <div v-else-if="errorIsServerLoadRelated" class="error-prompt">
          <div>Oops, it seems the <strong>server is busy</strong> at the moment.</div>
          <div>We are very sorry for the inconvenience.</div>
          <div>Please refresh the page and retry in a few moments.</div>
          <div>Thank you.</div>
        </div>

        <div v-if="errorIsNonRetryable" class="call-to-action-buttons">
          <button
            class="send-report"
            :style="sendReportButtonStyle"
            :disabled="sendingReport || successfullyReported"
            @click="sendReportClicked"
            >{{ sendReportButtonText }}</button
          >
          <button class="dont-report" :disabled="sendingReport" @click="closeErrorPopup">{{
            dontReportButtonText
          }}</button>
        </div>
        <div v-else-if="errorIsConnectionRelated || errorIsServerLoadRelated" class="call-to-action-buttons">
          <button class="refresh-page" :disabled="sendingReport" @click="refreshPageClicked">Refresh</button>
          <button class="close-popup" :disabled="sendingReport" @click="closeErrorPopup">Close</button>
        </div>

        <div class="more-details-container">
          <div class="more-details-expander" @click="moreDetailsExpanderClicked">
            <img
              :style="detailsExpanderArrowStyle"
              src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
              alt="expand arrow"
            />
            <div style="margin-left: 3px">More Details</div>
          </div>
          <div class="more-details" v-if="showMoreDetails">
            <div class="error-details">
              <code v-html="errorDetailsToDisplay"></code>
            </div>

            <div v-if="errorIsConnectionRelated || errorIsServerLoadRelated" class="hidden-report-button-container">
              <div>NOTE: This error may be temporary.</div>
              <div>Please refresh and try again first before reporting.</div>
              <button
                class="report-button"
                :style="sendReportButtonStyle"
                :disabled="sendingReport || successfullyReported"
                @click="sendReportClicked"
                >{{ sendReportButtonText }}</button
              >
            </div>
          </div>
        </div>

        <div class="error-reported" v-if="successfullyReported">
          Thank you for reporting the error.<br />
          The error has been sent to our Development Team<br />
          This will help us in improving 6G.
        </div>
        <div class="error-reported" v-else-if="failedToReport">
          Failed to send report.<br />
          Click Retry to try again.<br />
          Click Don't Report to close this screen.
        </div>
      </div>
    </div>

    <PopupV2
      :show="popupShow"
      :type="popupType"
      :title="popupTitle"
      :content="popupContent"
      :buttons="popupButtons"
      @buttonClicked="popupButtonClicked"
      :backgroundCancel="popupBgCancel"
    />

    <!-- Vue must not reconcile children manually moved into this overlay host. -->
    <div id="app-overlay-root" v-once></div>

    <Loader :isVisible="mainLoading" :loadingText="mainLoadingText" mainLoader :isFullScreen="loadingFullScreen" />
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

var signal;
var updateSignal;

export default {
  name: 'app',
  data: function () {
    return {
      loginDetails: {},

      errorDetails: null,
      errorType: '', // "nonRetryable" | "connection" | "serverLoad"
      successfullyReported: false,
      failedToReport: false,
      sendingReport: false,
      showMoreDetails: false,

      popupShow: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',
      popupButtons: [],
      popupBgCancel: false,
      popupResolve: null,

      allNoti: [],
      showNoti: [],

      mainLoading: false,
      mainLoadingText: '',
      loadingFullScreen: false,
    };
  },
  props: {},
  computed: {
    errorIsNonRetryable: function () {
      return this.errorType === 'nonRetryable' || this.errorType === '';
      // error type should never be empty, but handle it just in case
    },
    errorIsConnectionRelated: function () {
      return this.errorType === 'connection';
    },
    errorIsServerLoadRelated: function () {
      return this.errorType === 'serverLoad';
    },
    sendReportButtonText: function () {
      if (this.sendingReport) {
        return 'Sending Report . . .';
      } else if (this.successfullyReported) {
        return 'Reported';
      } else if (this.failedToReport) {
        return 'Retry';
      } else {
        return 'Report';
      }
    },
    sendReportButtonStyle: function () {
      return this.successfullyReported ? { 'background-color': 'green' } : {};
    },
    dontReportButtonText: function () {
      return this.successfullyReported ? 'Close' : "Don't Report";
    },
    detailsExpanderArrowStyle: function () {
      return {
        'margin-right': '3px',
        transform: `rotate(${this.showMoreDetails ? 0 : 180}deg)`,
        transition: '0.3s', // for rotate
      };
    },
    errorDetailsToDisplay: function () {
      let errorDetails = '';
      errorDetails += `${this.errorDetails?.error?.statusCode ?? ''}: ${this.errorDetails?.error?.statusText ?? ''}<br>`;
      errorDetails += this.errorDetails?.error?.errorResponse?.errorMessage ?? '';

      return errorDetails;
    },
  },
  methods: {
    closeNotiClicked: function (index) {
      this.showNoti.splice(index, 1);
    },
    getVersion: async function () {
      let version = [];
      if (window.location.hostname == 'localhost') {
        version.push({
          Version: 'Dev',
          PublishedDate: 'N/A',
          Description: `You're in development mode, there are no available versions`,
        });
      } else {
        version = (await axios.get('/Version/GetVersion?latestThree=true')).data;
      }

      this.$store.commit('updateVersion', version.reverse());
    },
    receiveVersionUpdate: async function (msg) {
      if (process.env.NODE_ENV != 'development') {
        this.showNoti.splice(0, 0, msg);
        this.allNoti.splice(0, 0, msg);
      }
    },
    receiveNoti: function (msg) {
      let showNoti = true;

      if (msg['user']) {
        if (!msg['user'].split(',').includes(this.loginDetails['LoginUserId'])) {
          showNoti = false;
        }
      }

      if (msg['group']) {
        if (!msg['group'].split(',').includes(this.loginDetails['Group'])) {
          showNoti = false;
        }
      }

      if (msg['company']) {
        if (!msg['company'].split(',').includes(this.loginDetails['CoRefname'])) {
          showNoti = false;
        }
      }

      if (!showNoti) {
        return;
      }

      if (this.showNoti.length == 3) {
        this.showNoti.splice(2, 1);
      }

      this.showNoti.splice(0, 0, msg);
      this.allNoti.splice(0, 0, msg);

      if (msg['timeout']) {
        setTimeout(() => {
          var index = this.showNoti.indexOf(msg);
          if (index >= 0) {
            this.showNoti.splice(index, 1);
          }
        }, msg['timeout']);
      }
    },
    getUserOptions: async function () {
      var userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');

      if (userOptionsData[0].SettingsValue) {
        var userOptionsObj = JSON.parse(userOptionsData[0].SettingsValue);
          const {
          BackgroundColor,
          PreferredDateFormat,
          PreferredJobOrder,
          PreferredCurrencyFormat,
          PreferredWeightFormat,
          PreferredVolumeFormat,
        } = userOptionsObj || {};
        BackgroundColor && this.$store.commit('updateBackgroundColor', BackgroundColor);
        PreferredDateFormat && this.$store.commit('updatePreferredDateFormat', PreferredDateFormat);
        PreferredJobOrder && this.$store.commit('updatePreferredJobOrder', PreferredJobOrder);
        PreferredCurrencyFormat && this.$store.commit('updateCurrencyFormat', PreferredCurrencyFormat.substring(0, 2));
        PreferredWeightFormat && this.$store.commit('updateWeightFormat', PreferredWeightFormat.substring(0, 2));
        PreferredVolumeFormat && this.$store.commit('updateVolumeFormat', PreferredVolumeFormat.substring(0, 2));
      }
      this.$bus.$emit('backColorChanged', this.$store.state['backgroundColor']);
    },
    getWeightFormat: async function () {
      const settingsitemData = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=WeightFormat');
      const settingsitemValue = settingsitemData?.[0].SettingsValue;
      if (settingsitemValue) this.$store.commit('updateWeightFormat', settingsitemValue);
      else console.warn('ERROR fetching WeightFormat from SettingsSystem, defaults to ,.4');
    },

    getVolumeFormat: async function () {
      const settingsitemData = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=VolumeFormat');
      const settingsitemValue = settingsitemData?.[0].SettingsValue;
      if (settingsitemValue) this.$store.commit('updateVolumeFormat', settingsitemValue);
      else console.warn('ERROR fetching VolumeFormat from SettingsSystem, defaults to ,.4');
    },

    getCurrencyFormat: async function () {
      const settingsitemData = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=CurrencyFormat');
      const settingsitemValue = settingsitemData?.[0].SettingsValue;
      if (settingsitemValue) this.$store.commit('updateCurrencyFormat', settingsitemValue);
      else console.warn('ERROR fetching CurrencyFormat from SettingsSystem, defaults to ,.2');
    },

    getMasterFileCodeFormat: async function () {
      const settingsitemData = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=MASTERNOSPACE');
      const settingsitemValue = settingsitemData?.[0].SettingsValue;
      if (settingsitemValue) this.$store.commit('updateMasterCodeFileFormat', settingsitemValue);
      else console.warn('ERROR fetching MASTERNOSPACE from SettingsSystem, defaults to 1');
    },

    getMasterFileNameFormat: async function () {
      const settingsitemData = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=MasterUpperCaseName');
      const settingsitemValue = settingsitemData?.[0].SettingsValue;
      if (settingsitemValue) this.$store.commit('updateMasterFileNameFormat', settingsitemValue);
      else console.warn('ERROR fetching MasterUpperCaseName from SettingsSystem, defaults to Y');
    },

    //find vuex.js for format defaults
    getFormatsFromAPI: async function () {
      this.getWeightFormat();
      this.getVolumeFormat();
      this.getMasterFileCodeFormat();
      this.getMasterFileNameFormat();
      this.getCurrencyFormat();
      this.getUserOptions(); //user options be last, since it will override the defaults/api formats
    },
     
    sendReportClicked: async function () {
      this.sendingReport = true;
      const errorReportResult = await this.$apiCallV2('/ErrorReport/SendReport', this.errorDetails);
      this.sendingReport = false;

      if (errorReportResult !== '0') {
        // failed to send report for some reason
        this.failedToReport = true;
        return;
      }

      // successfully sent report
      this.successfullyReported = true;
    },
    refreshPageClicked: function (pointerEvent) {
      location.reload();
    },
    closeErrorPopup: function (pointerEvent) {
      this.errorDetails = null;
      this.successfullyReported = false;
      this.failedToReport = false;
      this.showMoreDetails = false;
    },
    moreDetailsExpanderClicked: function (pointerEvent) {
      this.showMoreDetails = !this.showMoreDetails;
    },

    popupButtonClicked: function (e) {
      this.popupShow = false;
      this.popupResolve(e);
    },
  },
  async mounted() {
    //#region All bus events
    this.$bus.$on('userLoggedIn', async () => {
      this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
      this.getFormatsFromAPI();
    });

    this.$bus.$on('userLoggedOut', () => {
      this.loginDetails = {};
    });

    this.$bus.$on('nonRetryableAPIError', (details) => {
      console.log('non retryable error', details);

      this.errorDetails = {
        ...details,
      };
      this.errorDetails.error.errorType = 'Non Retryable (Frowning Face)';
      this.errorType = 'nonRetryable';
    });

    this.$bus.$on('connectionRelatedAPIError', (details) => {
      console.log('connection error', details);

      this.errorDetails = {
        ...details,
      };
      this.errorDetails.error.errorType = 'Connection Error (Broken Chain)';
      this.errorType = 'connection';
    });

    this.$bus.$on('serverLoadRelatedAPIError', (details) => {
      console.log('server load error', details);

      this.errorDetails = {
        ...details,
      };
      this.errorDetails.error.errorType = 'Server Load (Traffic Light)';
      this.errorType = 'serverLoad';
    });

    this.$bus.$on('mainShowAlert', (type, title, content, buttons, backCancel, resolve) => {
      if (type) {
        this.popupType = type;
      } else {
        this.popupType = '';
      }

      if (title) {
        this.popupTitle = title;
      } else {
        this.popupTitle = '';
      }

      if (content) {
        this.popupContent = content;
      } else {
        this.popupContent = '';
      }

      if (buttons) {
        this.popupButtons = buttons;
      } else {
        this.popupButtons = [];
      }

      if (backCancel) {
        this.popupBgCancel = true;
      } else {
        this.popupBgCancel = false;
      }

      this.popupShow = true;
      this.popupResolve = resolve;
    });

    this.$bus.$on('receivedNoti', (details) => {
      if (this.showNoti.length == 3) {
        this.showNoti.splice(2, 1);

        setTimeout(() => {
          this.showNoti.splice(0, 0, details);

          if (details['timeout']) {
            setTimeout(() => {
              var index = this.showNoti.indexOf(details);
              if (index >= 0) {
                this.showNoti.splice(index, 1);
              }
            }, details['timeout']);
          }
        }, 300);
      } else {
        this.showNoti.splice(0, 0, details);

        if (details['timeout']) {
          setTimeout(() => {
            var index = this.showNoti.indexOf(details);
            if (index >= 0) {
              this.showNoti.splice(index, 1);
            }
          }, details['timeout']);
        }
      }
    });

    this.$bus.$on('mainLoading', (text, fullScreen) => {
      this.mainLoading = text ? true : false;
      this.mainLoadingText = text;
      this.loadingFullScreen = fullScreen;
    });
    //#endregion

    db.removeExpired();

    signal = await this.$signal.init('notifications');
    updateSignal = await this.$signal.init('signalr', 'https://dsmlib.logistics.systems');
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.getVersion();

    if (this.loginDetails) {
      this.getFormatsFromAPI();
    }

    signal.on('ReceiveNoti', this.receiveNoti);
    updateSignal.on('6gUpdate', this.receiveVersionUpdate);

    window.addEventListener('click', (e) => {
      this.$bus.$emit('windowClick', e);
    });
  },
  destroyed() {
    signal.off('ReceiveNoti');
    updateSignal.off('6gUpdate');
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.app-main {
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  align-items: center;
  // background-color: green;

  > .error-popup {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: 9999999999999999999;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    > .error-content {
      width: 60%;
      padding: 20px 0;
      border-radius: 10px;
      background-color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      > .error-prompt {
        margin-bottom: 15px;
      }

      > .call-to-action-buttons {
        display: flex;
        flex-direction: row;

        > .send-report {
          margin-right: 5px;
          background-color: red;
          color: white;
          font-size: 1.3em;
        }

        > .refresh-page {
          margin-right: 5px;
          font-size: 1.3em;
        }

        > .dont-report,
        > .close-popup {
          margin-left: 5px;
          background-color: gray;
          color: white;
          font-size: 1.3em;
        }

        > button:disabled {
          background-color: lightgray;
          opacity: 0.7;
        }
      }

      > .more-details-container {
        margin-top: 10px;
        width: 100%;
        font-size: 0.85em;
        display: flex;
        flex-direction: column;
        align-items: center;

        > .more-details-expander {
          display: flex;
          flex-direction: row;
          cursor: pointer;
        }

        > .more-details {
          width: calc(100% - 10px);

          > .error-details {
            background-color: lightgray;
            white-space: nowrap;
            overflow-x: scroll;
            user-select: text;

            > code {
              color: black;
            }
          }

          > .hidden-report-button-container > .report-button {
            background-color: red;
            color: white;
          }
        }
      }

      > .error-reported {
        font-size: 0.75em;
      }
    }
  }
}

.noti-block {
  position: fixed;
  right: 5px;
  top: 60px;
  z-index: 999999;
}

.noti-details {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 5px;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid black;
  margin-bottom: 5px;
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  min-height: 50px;

  > .noti-title {
    display: flex;
    align-items: center;
    width: 100%;
  }

  > .close-noti {
    cursor: pointer;
    position: absolute;
    right: 3px;
    top: 3px;
    height: 15px;
  }

  > .noti-text {
    width: 235px;
    font-size: 12px;
    font-weight: bold;
    margin-top: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:hover {
      white-space: pre-wrap;
    }
  }
}

.noti-enter-active,
.noti-leave-active {
  transition: all 0.3s;
}

.noti-enter, .noti-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(270px);
}
</style>
